export const ANIMATION_DIRECTION = {
  BACKWARD: 'fadeInLeft',
  FORWARD: 'fadeInRight',
};
